import React, { useContext, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
// import pandaImage from "../../../assets/insight_panda.png";
import panda from "../../../assets/Panda2.png";
import continueConversation from "../../../assets/ContinueConversation.png";
import endWithoutConclution from "../../../assets/EndWithoutConclution.png";
import endWithConclution from "../../../assets/EndWithConclution.png";
// import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../UserContext";
import Conclusion from "./ConclusionPopup";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import CelebrationPage from "./CelebrationPage";
import { usePopupWindowCloseHandler } from "../../../utils/useWindowCloseHandler.js";

const InsightPopup = ({
  summary,
  questions,
  newSession,
  step_number,
  onClose,
  onEndSession,
  session_Goal,
  userId,
  subsectionId,
  onSessionComplete,
}) => {
  const { user } = useContext(UserContext);
  // const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [answers, setAnswers] = useState({});
  const [subpage, setSubpage] = useState(1);
  const [action, setAction] = useState("");
  const [actionValue, setActionValue] = useState("");  // eslint-disable-line no-unused-vars
  const [showFeedback, setShowFeedback] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const apiBaseURL = process.env.REACT_APP_BACKEND_API_URL;
  const [conclutionPopup, setConclutionPopup] = useState(false);
  const [questionHasSubitted, setQuestionHasSubitted] = useState(false);
  const [conclusionData, setConclusionData] = useState("");
  const [thankYouData, setThankYouData] = useState("");
  const [summeryData, setSummeryData] = useState("");
  const [insightSummery, setInsightSummery] = useState("");
  const [oldPerspective, setOldPerspective] = useState("");
  const [newPerspective, setNewPerspective] = useState("");
  const [blindSpotQuestions, setBlindSpotQuestions] = useState([]);
  const [userInsight, setUserInsight] = useState("");
  const [sessionGoal, setSessionGoal] = useState("");  // eslint-disable-line no-unused-vars
  const [actionData, setActionData] = useState("");
  const [insightData, setInsightData] = useState("");
  const [insightFromUser, setInsightFromUser] = useState("");
  const [sessionStoryId, setSessionStoryId] = useState("");
  const [direction, setDirection] = useState(0);  // eslint-disable-line no-unused-vars
  const isUserInsightEmpty = !userInsight;
  const [optionSelectedFromGiven, setOptionSelectedFromGiven] = useState(false);

  usePopupWindowCloseHandler(
    newSession,
    user?.user_id,
    apiBaseURL,
    !conclutionPopup && !showFeedback
  );

  const roadmapSteps = [
    { id: 1, title: "Questions" },
    { id: 2, title: "Shift In Perspective" },
    { id: 3, title: "Quotes" },
    { id: 4, title: "Next Step" },
  ];

  const questionsData = {
    Question1: Array.isArray(questions?.Question1)
      ? questions.Question1
      : questions?.Question1
      ? [questions.Question1]
      : [],

    Question2: Array.isArray(questions?.Question2)
      ? questions.Question2
      : questions?.Question2
      ? [questions.Question2]
      : [],
  };

  const options = [
    {
      id: "yes",
      text: "Yes, I want to think about next steps with you.",
      imageUrl: continueConversation,
    },
    {
      id: "empowered",
      text: "No, I feel empowered already and good where I am.",
      imageUrl: endWithConclution,
    },
    {
      id: "no",
      text: "No, I feel this was not helpful.",
      imageUrl: endWithoutConclution,
    },
  ];

  const handleAnswer = (question, answer) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [question]: answer, // Only updates when clicked
    }));
  };

  const allQuestionsAnswered =
    questionsData.Question1.every((_, index) =>
      answers.hasOwnProperty(`Question1-${index}`)
    ) &&
    questionsData.Question2.every((_, index) =>
      answers.hasOwnProperty(`Question2-${index}`)
    );

  const handleActionAnswer = (key, value) => {
    setAnswers((prev) => ({ ...prev, [key]: value }));
    if (key === "takeAction") {
      setAction(value);
    }
  };

  const isAnyAnswerSelected = Object.values(answers).some(
    (answer) => answer !== null
  );

  const handleSubmit = async () => {
    setIsSubmitting(true);
    let formattedData = [];
    questionsData.Question1.forEach((question, index) => {
      formattedData.push(
        question,
        answers[`Question1-${index}`] ? "Yes" : "No"
      );
    });
    questionsData.Question2.forEach((question, index) => {
      formattedData.push(
        question,
        answers[`Question2-${index}`] ? "Yes" : "No"
      );
    });
    const payload = {
      responses: formattedData,
      action: Array.isArray(userInsight) ? userInsight.join(" ") : userInsight,
      session_id: newSession,
      step_number: step_number,
      session_Goal: session_Goal,
    };

    console.log("Payload to send:", payload);
    const user_response = payload.responses[payload.responses.length - 1];

    try {
      const response = await fetch(`${apiBaseURL}/insight_responses`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        console.log("API Response:", data);

        if (action === "yes") {
          console.log("Proceeding with fostering accountability.");
          onClose(user_response);
        } else if (action === "empowered") {
          appendInSessionStep();
          genrateConclution();
        } else {
          console.log("Ending session based on user action.");
          setShowFeedback(true);
        }
      } else {
        console.error("Failed API response:", data);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const appendInSessionStep = async () => {
    try {
      const payload = {
        coachee_response: "",
        focus_popup_required: 1,
        record_from_focus_popup: 0,
        selected_focus_choice: 400,
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
        conversation_summary: "",
      };

      const response = await fetch(
        `${apiBaseURL}/users/${user.user_id}/session/${newSession}/step`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
      const data = await response.json();
      if (response.ok) {
        console.log(data);
        setThankYouData(data.thank_you);
        setConclusionData(data.conclusion);
        setSummeryData(data.conclusion_summery);
      } else {
        console.error("Error in regeneration:", data.detail);
      }
    } catch (error) {
      console.error("Error during regeneration:", error);
    }
  };

  const genrateConclution = async () => {
    try {
      const response = await fetch(`${apiBaseURL}/conclusion/${newSession}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (response.ok) {
        console.log(data);
        setConclutionPopup(true);
        setActionData(data.conclusion.session_actions);
        setInsightData(data.conclusion.session_insights);
        setSessionGoal(data.conclusion.session_goal);
        setInsightFromUser(data.question_response);
        setSessionStoryId(data.story_id);
        // setSummeryData(data.conclusion_summery);
      } else {
        console.error("Error in submission:", data.detail);
      }
    } catch (error) {
      console.error("Error during submission:", error);
    }
  };

  const getUserInsights = async () => {
    setIsSubmitting(true);
    setQuestionHasSubitted(true);
    let formattedData = [];
    questionsData.Question1.forEach((question, index) => {
      formattedData.push(
        question,
        answers[`Question1-${index}`] ? "Yes" : "No"
      );
    });
    questionsData.Question2.forEach((question, index) => {
      formattedData.push(
        question,
        answers[`Question2-${index}`] ? "Yes" : "No"
      );
    });
    const payload = {
      responses: formattedData,
      action: "null - nothing",
      session_id: newSession,
      step_number: step_number,
      session_Goal: session_Goal,
    };

    console.log("Payload to send:", payload);

    try {
      const response = await fetch(`${apiBaseURL}/insight_summery`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (response.ok) {
        console.log("API Response:", data);
        setIsSubmitting(false);
        setInsightSummery(data.shift_in_perspective_summary);
        setBlindSpotQuestions(data.blind_spot || []);
        setOldPerspective(data.old_perspective);
        setNewPerspective(data.new_Perspective);
        setCurrentPage(currentPage + 1);
      } else {
        console.error("Failed API response:", data);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const Pagination = () => (
    <div className="flex items-center space-x-2 sm:space-x-3">
      {roadmapSteps.map((step) => (
        <button
          key={step.id}
          className={`w-3 h-3 sm:w-4 sm:h-4 rounded-full transition ${
            currentPage === step.id ? "bg-[#54B0AF]" : "bg-gray-300"
          }`}
          // onClick={() => setCurrentPage(step.id)}
        />
      ))}
    </div>
  );

  const pageVariants = {
    initial: (direction) => ({ opacity: 1 }),
    animate: { opacity: 1 },
  };

  const nextPage = () => {
    if (currentPage < 5) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <>
      {conclutionPopup ? (
        <Conclusion
          conclusion={conclusionData}
          thankyou={thankYouData}
          summary={summeryData}
          action={actionData}
          insight={insightData}
          yourInsight={insightFromUser}
          session_goal={session_Goal}
          newSession={newSession}
          sessionStoryId={sessionStoryId}
          userId={userId}
          subsectionId={subsectionId}
          onSessionComplete={onSessionComplete}
        />
      ) : (
        <div className="fixed inset-0 bg-gray-700 bg-opacity-80 flex justify-center items-center z-50 font-gotham p-2 sm:p-4">
          {/* <div className="bg-white mt-6 rounded-2xl shadow-lg w-[86%] md:w-[80%] lg:w-[65%] xl:w-[65%] lg:max-w-[900px] xl:max-w-[1000px] overflow-hidden"> */}
          <div className="bg-white mt-2 sm:mt-6 rounded-2xl shadow-lg w-full max-w-[1000px] mx-auto flex flex-col max-h-[95vh] sm:max-h-[90vh] overflow-hidden">
            {/* Header Dots */}
            <div className="flex gap-3 ml-4 py-2">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="w-4 h-4 rounded-full"></div>
              ))}
            </div>
            {!showFeedback ? (
              <motion.div
                className="relative bg-white bg-opacity-100 rounded-lg flex flex-col gap-2 sm:gap-4 flex-1 min-h-0"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                <div className="flex-1 flex flex-col items-center w-full rounded-lg min-h-0 overflow-hidden">
                  <AnimatePresence custom={direction} mode="wait">
                    {currentPage === 1 && (
                      <motion.div
                        key="page-2"
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={direction}
                        transition={{ duration: 0.5 }}
                        className="w-full h-full flex flex-col rounded-lg overflow-hidden"
                      >
                        <div className="relative w-full bg-gray-200 mb-2 sm:mb-4 flex-shrink-0 overflow-hidden flex items-center justify-start px-4 sm:px-6 h-24 sm:h-32 md:h-40 lg:h-48">
                          <motion.h2
                            className="text-sm sm:text-lg md:text-2xl xl:text-3xl font-bold text-[#323232] text-start z-10"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.1 }}
                          >
                            {currentPage === 1
                              ? summary
                              : "Does this resonate with you?"}
                          </motion.h2>

                          <motion.img
                            src={panda}
                            alt="Panda"
                            className="absolute bottom-0 right-0 h-full object-bottom object-contain"
                            initial={{
                              scale: 1.5,
                              x: -50,
                              scaleX: 1,
                            }}
                            animate={{
                              scale: 1,
                              x: 0,
                              scaleX: 1,
                            }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>
                        <div className="flex-1 min-h-0 overflow-y-auto px-2 sm:px-4">
                          <div className="w-full flex justify-center items-center">
                            <motion.div
                              className="flex flex-col md:flex-row items-stretch justify-center space-y-3 md:space-x-6 md:space-y-0 w-full max-w-4xl"
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              exit={{ opacity: 0 }}
                              transition={{
                                duration: 1,
                                exit: { duration: 0.3 },
                              }}
                            >
                              {subpage === 1 &&
                                questionsData.Question1.map(
                                  (question, index) => (
                                    <div
                                      key={`Question1-${index}`}
                                      className="w-full md:w-1/2 md:max-w-[424px] p-3 sm:p-4 md:p-6 flex flex-col border-2 border-[#E3E3E3] bg-[#F5F5F5] rounded-xl min-h-[200px] sm:min-h-[250px]"
                                    >
                                      <div className="flex-1 mb-4">
                                        <motion.p
                                          className="text-[#323232] font-gotham text-sm sm:text-md md:text-lg font-medium leading-5 md:leading-6"
                                          initial={{ opacity: 0 }}
                                          animate={{ opacity: 1 }}
                                          exit={{ opacity: 0 }}
                                          transition={{
                                            duration: 1,
                                            exit: { duration: 0.3 },
                                          }}
                                        >
                                          {question}
                                        </motion.p>
                                      </div>
                                      <div className="flex flex-col space-y-2">
                                        <button
                                          className={`flex items-center gap-2 px-4 py-2 border rounded-lg bg-white transition-all ${
                                            answers[`Question1-${index}`] ===
                                            true
                                              ? "border-[#54B0AF] "
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleAnswer(
                                              `Question1-${index}`,
                                              true
                                            )
                                          }
                                        >
                                          <span
                                            className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border ${
                                              answers[`Question1-${index}`] ===
                                              true
                                                ? "border-[#54B0AF] bg-[#54B0AF]"
                                                : "border-[#323232]"
                                            }`}
                                          ></span>
                                          <span className="text-base sm:text-lg md:text-xl font-gotham font-medium text-[#323232]">
                                            Yes
                                          </span>
                                        </button>
                                        <button
                                          className={`flex items-center gap-2 px-4 py-2 border bg-white rounded-lg transition-all ${
                                            answers[`Question1-${index}`] ===
                                            false
                                              ? "border-[#54B0AF]"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleAnswer(
                                              `Question1-${index}`,
                                              false
                                            )
                                          }
                                        >
                                          <span
                                            className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border ${
                                              answers[`Question1-${index}`] ===
                                              false
                                                ? "border-[#54B0AF] bg-[#54B0AF]"
                                                : "border-[#323232]"
                                            }`}
                                          ></span>
                                          <span className="text-base sm:text-lg md:text-xl font-gotham font-medium text-[#323232]">
                                            No
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  )
                                )}
                              {subpage === 2 &&
                                questionsData.Question2.map(
                                  (question, index) => (
                                    <div
                                      key={`Question2-${index}`}
                                      className="w-full md:w-1/2 md:max-w-[424px] p-3 sm:p-4 md:p-6 flex flex-col border-2 border-[#E3E3E3] bg-[#F5F5F5] rounded-xl min-h-[200px] sm:min-h-[250px]"
                                    >
                                      <div className="flex-1 mb-4">
                                        <motion.p
                                          className="text-[#323232] font-gotham text-sm sm:text-md md:text-lg font-medium leading-5 md:leading-6"
                                          initial={{ opacity: 0 }}
                                          animate={{ opacity: 1 }}
                                          exit={{ opacity: 0 }}
                                          transition={{
                                            duration: 1,
                                            exit: { duration: 0.3 },
                                          }}
                                        >
                                          {question}
                                        </motion.p>
                                      </div>
                                      <div className="flex flex-col space-y-2">
                                        <button
                                          className={`flex items-center gap-2 px-4 py-2 border bg-white rounded-lg transition-all ${
                                            answers[`Question2-${index}`] ===
                                            true
                                              ? "border-[#54B0AF]"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleAnswer(
                                              `Question2-${index}`,
                                              true
                                            )
                                          }
                                        >
                                          <span
                                            className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border ${
                                              answers[`Question2-${index}`] ===
                                              true
                                                ? "border-[#54B0AF] bg-[#54B0AF]"
                                                : "border-[#323232]"
                                            }`}
                                          ></span>
                                          <span className="text-base sm:text-lg md:text-xl font-gotham font-medium text-[#323232]">
                                            Yes
                                          </span>
                                        </button>
                                        <button
                                          className={`flex items-center gap-2 px-4 py-2 border bg-white rounded-lg transition-all ${
                                            answers[`Question2-${index}`] ===
                                            false
                                              ? "border-[#54B0AF]"
                                              : ""
                                          }`}
                                          onClick={() =>
                                            handleAnswer(
                                              `Question2-${index}`,
                                              false
                                            )
                                          }
                                        >
                                          <span
                                            className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full border ${
                                              answers[`Question2-${index}`] ===
                                              false
                                                ? "border-[#54B0AF] bg-[#54B0AF]"
                                                : "border-[#323232]"
                                            }`}
                                          ></span>
                                          <span className="text-base sm:text-lg md:text-xl font-gotham font-medium text-[#323232]">
                                            No
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  )
                                )}
                            </motion.div>
                          </div>
                        </div>
                      </motion.div>
                    )}
                    {currentPage === 2 && (
                      <motion.div
                        key="page-3"
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={direction}
                        transition={{ duration: 0.3 }}
                        className="w-full h-full flex flex-col rounded-lg overflow-hidden"
                      >
                        <div className="relative w-full bg-gray-200 mb-2 sm:mb-4 flex-shrink-0 overflow-hidden flex items-center justify-start px-4 sm:px-6 h-20 sm:h-24 md:h-32 lg:h-40">
                          <motion.h2
                            className="text-sm sm:text-lg md:text-2xl xl:text-3xl font-bold text-[#323232] text-start z-10"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.1 }}
                          >
                            My Observation.
                          </motion.h2>

                          <motion.img
                            src={panda}
                            alt="Panda"
                            className="absolute bottom-0 right-0 h-full object-bottom object-contain"
                            initial={{
                              scale: 1.5,
                              x: -50,
                              scaleX: 1,
                            }}
                            animate={{
                              scale: 1,
                              x: 0,
                              scaleX: 1,
                            }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>
                        <motion.div
                          className="flex-1 min-h-0 overflow-y-auto px-2 sm:px-4"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{
                            duration: 0.3,
                            exit: { duration: 0.2 },
                          }}
                        >
                          <div className="w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 max-w-4xl">
                            <div className="bg-white rounded-xl shadow-lg shadow-gray-300 p-4 sm:p-6 border border-gray-300">
                              <h3 className="text-base sm:text-lg md:text-xl font-gotham font-bold text-[#484848]">
                                Before we started,
                              </h3>
                              <h3 className="text-base sm:text-lg md:text-xl font-gotham font-bold text-[#484848] mb-2 sm:mb-3">
                                you...
                              </h3>
                              <hr className="my-2 md:my-3 border-gray-300" />
                              <p className="text-[#484848] font-normal font-gotham text-sm sm:text-md md:text-lg leading-5 md:leading-relaxed">
                                {oldPerspective}
                              </p>
                            </div>

                            {/* After */}
                            <div className="bg-white rounded-xl shadow-lg shadow-gray-300 p-4 sm:p-6 border border-gray-300">
                              <h3 className="text-base sm:text-lg md:text-xl font-gotham  font-bold text-[#484848]">
                                After the perspective shift,
                              </h3>
                              <h3 className="text-base sm:text-lg md:text-xl font-gotham font-bold text-[#484848] mb-2 sm:mb-3">
                                you...
                              </h3>
                              <hr className="my-2 md:my-3 border-gray-300" />
                              <p className="text-[#484848] font-normal font-gotham text-sm sm:text-md md:text-lg leading-5 md:leading-relaxed">
                                {newPerspective}
                              </p>
                            </div>
                          </div>
                        </motion.div>
                      </motion.div>
                    )}
                    {currentPage === 3 && (
                      <motion.div
                        key="page-1"
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={direction}
                        transition={{ duration: 0.5 }}
                        className="w-full h-full flex flex-col rounded-xl bg-white overflow-hidden"
                      >
                        {/* Header Image Section */}
                        <div className="relative w-full bg-gray-200 mb-2 sm:mb-4 flex-shrink-0 overflow-hidden flex items-center justify-start px-4 sm:px-6 h-20 sm:h-24 md:h-32 lg:h-40">
                          <motion.h2
                            className="w-[50%] text-sm sm:text-lg md:text-2xl xl:text-3xl font-gotham font-bold text-[#323232] text-start z-10"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.1 }}
                          >
                            Could these be your Blind Spots?
                          </motion.h2>

                          <motion.img
                            src={panda}
                            alt="Panda"
                            className="absolute bottom-0 right-0 h-full object-bottom object-contain"
                            initial={{
                              scale: 1.5,
                              x: -50,
                              scaleX: 1,
                            }}
                            animate={{
                              scale: 1,
                              x: 0,
                              scaleX: 1,
                            }}
                            transition={{ duration: 0.5 }}
                          />
                        </div>

                        {/* Main Content Section */}
                        <div className="flex-1 min-h-0 overflow-y-auto px-2 sm:px-4 bg-white">
                          <div className="pb-3 border-b border-[#d8d6d6] mb-3">
                            <p className="text-[#323232] font-bold font-gotham text-base sm:text-lg lg:text-2xl leading-relaxed lg:leading-loose">
                              {insightSummery}
                            </p>
                          </div>

                          {/* Blind Spot Questions */}
                          {blindSpotQuestions.length > 0 && (
                            <div className="space-y-2">
                              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 pb-4">
                                {blindSpotQuestions.map((q, idx) => (
                                  <div
                                    key={idx}
                                    className="relative bg-white rounded-xl shadow-lg p-4 sm:p-5 hover:shadow-xl transition-shadow duration-200 min-h-[120px] sm:min-h-[140px]"
                                  >
                                    <input
                                      type="checkbox"
                                      checked={userInsight.includes(q)}
                                      onChange={() => {
                                        setUserInsight((prev) =>
                                          prev.includes(q)
                                            ? prev.filter((item) => item !== q)
                                            : [...prev, q]
                                        );
                                      }}
                                      className="absolute h-5 w-5 sm:h-6 sm:w-6 rounded-lg border-2 border-[#54B0AF] bg-white 
                checked:bg-[#54B0AF] checked:border-[#54B0AF]
                focus:ring-2 focus:ring-[#54B0AF] focus:ring-offset-2
                transition-all duration-200 top-3 right-3
                cursor-pointer appearance-none"
                                      style={{
                                        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3E%3C/svg%3E")`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        backgroundSize: "70%",
                                      }}
                                    />
                                    <p className="text-[#484848] pr-8 pt-2 sm:pt-4 text-sm sm:text-base leading-snug font-gotham font-[400]">
                                      {q}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </motion.div>
                    )}
                    {currentPage === 4 && (
                      <motion.div
                        key="page-5"
                        variants={pageVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        custom={direction}
                        transition={{ duration: 0.5 }}
                        className="w-full h-full flex flex-col rounded-lg p-2 sm:p-4 lg:p-6 overflow-y-auto scrollbar-hide"
                      >
                        <motion.div
                          className="space-y-4 flex-1"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          transition={{ duration: 0.2 }}
                        >
                          {/* Title */}
                          <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold text-[#323232] w-full text-start mb-4 sm:mb-6">
                            Ready for next steps?
                          </h2>

                          <div className="rounded-lg items-center justify-center scrollbar-hide">
                            <div className="flex flex-col lg:flex-row justify-center items-stretch gap-3 sm:gap-4 max-w-6xl mx-auto scrollbar-hide">
                              {options.map((option) => (
                                <div
                                  key={option.id}
                                  className={`relative p-3 sm:p-4 border-2 rounded-2xl shadow-md cursor-pointer transition-all flex flex-col items-center text-center w-full lg:w-1/3 hover:border-[#54B0AF] min-h-[200px] sm:min-h-[240px] ${
                                    answers["takeAction"] === option.id
                                      ? "border-[#54B0AF] ring-2 ring-[#54B0AF]"
                                      : "border-gray-300"
                                  }`}
                                  onClick={() => {
                                    handleActionAnswer("takeAction", option.id);
                                    setActionValue(option.text);
                                    setOptionSelectedFromGiven(true);
                                  }}
                                >
                                  <div className="flex-1 flex items-center justify-center">
                                    <img
                                      src={option.imageUrl || ""}
                                      alt={option.text}
                                      className="w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 object-contain"
                                    />
                                  </div>
                                  <p className="text-sm sm:text-base lg:text-lg font-medium font-gotham mt-2 sm:mt-3 px-2">
                                    {option.text}
                                  </p>

                                  {/* Info hover tip */}
                                  {(option.id === "no" ||
                                    option.id === "empowered") && (
                                    <div className="absolute left-1/2 transform -translate-x-1/2 top-full mt-2 w-max px-4 py-2 text-sm text-white bg-black rounded-md opacity-0 group-hover:opacity-100 transition-opacity z-50">
                                      Choosing this option will end the
                                      conversation.
                                    </div>
                                  )}

                                  {/* Selected Dot */}
                                  {answers["takeAction"] === option.id && (
                                    <div className="absolute top-2 right-2 w-4 h-4 sm:w-5 sm:h-5 bg-[#54B0AF] rounded-full flex items-center justify-center">
                                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full" />
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </motion.div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
                <div className="flex-shrink-0 flex justify-between items-center w-full p-3 sm:p-4 bg-white">
                  <div className="flex items-center justify-start">
                    <Pagination />
                  </div>
                  <div className="flex items-center justify-end space-x-2 sm:space-x-3">
                    <button
                      className="flex items-center justify-center px-4 py-2 sm:px-6 sm:py-2 rounded-full text-xl sm:text-2xl bg-gray-300 text-gray-400 hover:bg-[#54B0AF] hover:text-white disabled:opacity-50 transition-colors"
                      onClick={() => {
                        if (currentPage === 1 && subpage === 2) {
                          setSubpage(subpage - 1);
                        } else {
                          prevPage();
                        }
                      }}
                      disabled={
                        subpage === 1 ||
                        (currentPage === 2 && questionHasSubitted)
                      }
                    >
                      <FiArrowLeft />
                    </button>
                    {currentPage === 4 ? (
                      <button
                        className={`flex items-center text-sm sm:text-base justify-center px-4 py-2 sm:px-6 sm:py-2 rounded-full transition-colors ${
                          isAnyAnswerSelected && optionSelectedFromGiven
                            ? `bg-[#54B0AF] text-white hover:bg-teal-600`
                            : "bg-[#CACACA] text-gray-600 cursor-not-allowed"
                        }`}
                        onClick={handleSubmit}
                        disabled={
                          isSubmitting ||
                          !(optionSelectedFromGiven && isAnyAnswerSelected)
                        }
                      >
                        {isSubmitting ? "Submitting..." : "Submit"}
                      </button>
                    ) : (
                      <button
                        className={`flex items-center justify-center text-sm sm:text-base font-medium px-4 py-2 sm:px-6 sm:py-2 rounded-full transition-colors ${
                          isSubmitting ||
                          (currentPage === 1 &&
                            subpage === 2 &&
                            !allQuestionsAnswered) ||
                          (currentPage === 4 && isUserInsightEmpty)
                            ? "bg-gray-200 text-gray-600 cursor-not-allowed"
                            : "bg-[#54B0AF] text-white hover:bg-teal-600"
                        }`}
                        onClick={() => {
                          if (currentPage === 1 && subpage === 1) {
                            setSubpage(subpage + 1);
                          } else if (currentPage === 1 && subpage === 2) {
                            if (allQuestionsAnswered) getUserInsights();
                          } else {
                            nextPage();
                          }
                        }}
                        disabled={
                          isSubmitting ||
                          (currentPage === 1 &&
                            subpage === 2 &&
                            !allQuestionsAnswered) ||
                          (currentPage === 4 && isUserInsightEmpty)
                        }
                      >
                        {currentPage === 1 && subpage === 2 ? (
                          isSubmitting ? (
                            "Submitting..."
                          ) : (
                            "Submit"
                          )
                        ) : (
                          <FiArrowRight className="text-xl sm:text-2xl" />
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </motion.div>
            ) : (
              <CelebrationPage newSession={newSession} useCase="not_helpful" />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default InsightPopup;